import React, { Component } from "react";
import { Field, reduxForm, change, formValueSelector } from "redux-form";
import { bindActionCreators } from "redux";
import { TextField } from "redux-form-material-ui";
import DatePicker from "material-ui/DatePicker";
import { Card, CardText } from "material-ui/Card";
import { connect } from "react-redux";
import {
	actionCreateHoliday,
	actionUpdateHoliday,
	actionCopyHoliday
} from "../../actions/HolidayActions";
import { required } from "../../common/validaciones";
import { RaisedButton, FlatButton } from "material-ui";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE,
	MODE_CRU_SHOW
} from "../../actions/ActionConstants";
import { HOLIDAYS } from "../../config/RoutesConstants";
import Util, { SUCCESS, ERROR, WARNING } from "../../common/Util";
import UtilPC from "../../common/UtilPC";
import "./Holidays.css";
import { ROL_ADMIN, ROL_SUB_ADMIN } from "../../common/Constants";

class HolidayForm extends Component {
	constructor(props) {
		super(props);
		let state =
			this.props.modeCRU === MODE_CRU_CREATE
				? this.returnStateNewHoliday()
				: this.props.modeCRU === MODE_CRU_UPDATE
					? this.returnStateEditHoliday()
					: this.returnStateShowHoliday();
		this.state = state;
		this.onHolidayDateChange = this.onHolidayDateChange.bind(this);
		this.dispatchOnChange = this.dispatchOnChange.bind(this);
		this.initializeValues = this.initializeValues.bind(this);
		this.returnOnSubmit = this.returnOnSubmit.bind(this);
		this.formatDate = this.formatDate.bind(this);
	}

	componentWillMount() {
		if (
			!this.props.modeCRU ||
			(this.props.rol !== ROL_ADMIN && this.props.rol !== ROL_SUB_ADMIN)
		) {
			this.props.history.push(HOLIDAYS);
		} else {
			if (this.props.modeCRU === MODE_CRU_CREATE) {
				//this.props.actionGetCategoriesList(null, null, null);
				this.initializeValues(false);
			} else {
				if (
					this.props.modeCRU === MODE_CRU_UPDATE ||
					this.props.modeCRU === MODE_CRU_SHOW
				) {
					this.initializeValues(true);
				}
			}
		}
	}

	returnStateShowHoliday() {
		const state = {
			enableField: true
		};
		return state;
	}

	initializeValues(flag) {
		const formValues = this.props.formValues;
		if (flag) {
			this.setState({
				title: "Modificar Holiday",
				subTitle: "Edite Holiday"
			});
			const { name, date } = this.props.holiday;
			this.props.initialize({
				...formValues,
				name,
				date
			});
			//TODO
		} else {
			this.setState({
				title: "Alta Holiday",
				subTitle: "Agrege Holiday"
			});
			this.props.initialize({
				...formValues,
				name: null,
				date: null
			});
		}
	}

	returnStateNewHoliday() {
		let newState = {};
		return newState;
	}

	returnStateEditHoliday() {
		let editState = {};
		return editState;
	}
	dispatchOnChange(field, value) {
		this.props.dispatch(change("HolidayForm", field, value));
	}

	onHolidayDateChange(event, date) {
		this.setState({
			date
		});
		this.dispatchOnChange("date", date);
		this.onChangeDateField("date", date);
	}
	onChangeDateField(field, date) {
		this.setState({
			errors: {
				...this.state.errors,
				[field]: ""
			}
		});
	}
	formatDate(date) {
		//date = JSON.parse(JSON.stringify(date));
		let formatDate = Util.formatDateToShowNotHour(date);
		return formatDate;
	}

	onSubmit(formValues) {
		const values = JSON.parse(JSON.stringify(formValues));
		values.date = Util.formatDateToISODate(values.date);
		if (this.props.modeCRU === MODE_CRU_CREATE) {
			this.props.actionCreateHoliday(values, this.returnOnSubmit);
		} else if (this.props.modeCRU === MODE_CRU_UPDATE) {
			values.id = this.props.holiday.id;
			this.props.actionUpdateHoliday(
				this.props.holiday.id,
				values,
				this.returnOnSubmit
			);
		} else
			this.props.actionCopyHoliday(
				this.props.holiday.id,
				values,
				this.returnOnSubmit
			);
	}

	returnOnSubmit(response) {
		if (this.props.modeCRU === MODE_CRU_CREATE) {
			if (response === SUCCESS) {
				Util.showNoty(SUCCESS, "Feriado Creado");
				this.props.history.push(HOLIDAYS);
			} else if (response === ERROR) {
				Util.showNoty(ERROR, "Error al crear holiday");
			} else {
				Util.showNoty(
					WARNING,
					"Error al crear holiday, ya existe una holiday con dicho nombre"
				);
			}
		} else if (this.props.modeCRU === MODE_CRU_UPDATE) {
			if (response === SUCCESS) {
				Util.showNoty(SUCCESS, "Feriado Modificado");
				this.props.history.push(HOLIDAYS);
			} else if (response === ERROR) {
				Util.showNoty(ERROR, "Error al modificar holiday");
			} else {
				Util.showNoty(
					WARNING,
					"Error al modificar holiday, ya existe una holiday con dicho nombre"
				);
			}
		} else if (response === SUCCESS) {
			Util.showNoty(SUCCESS, "Holiday y promocodes copiados exitosamente");
			this.props.history.push(HOLIDAYS);
		} else if (response === ERROR) {
			Util.showNoty(ERROR, "Error al copiar holiday");
		} else
			Util.showNoty(
				WARNING,
				"Error al copiar holiday, ya existe una holiday con dicho nombre"
			);
	}

	ableToEdit = () => {
		return this.state.enableField;
	};

	render() {
		const { handleSubmit } = this.props;
		return (
			<div className="center">
				<Card className="card">
					{UtilPC.renderCardTitleCRU(this.props.modeCRU, "Feriados")}
					<CardText>
						<form>
							<div className="content-papercard">
								<Field
									ref="name"
									name="name"
									component={TextField}
									floatingLabelText="Nombre"
									validate={[required]}
									fullWidth
									floatingLabelFixed={false}
									disabled={this.ableToEdit()}
								/>
								<DatePicker
									ref="date"
									name="date"
									onChange={this.onHolidayDateChange}
									floatingLabelText="Fecha del Feriado"
									floatingLabelFixed={false}
									hintText="dd/mm/aaaa"
									value={
										this.props.formValues.date
											? new Date(this.props.formValues.date)
											: null
									}
									fullWidth
									minDate={this.props.minDateValue}
									maxDate={this.props.maxDateValue}
									errorText={this.props.errorDateFrom}
									formatDate={this.formatDate}
									disabled={this.ableToEdit()}
								/>
							</div>
							<div>
								<FlatButton
									label="Cancelar"
									onClick={() => {
										this.props.history.push(HOLIDAYS);
									}}
									style={{ margin: 5 }}
								/>
								<RaisedButton
									label="Aceptar"
									primary
									style={{ margin: 5 }}
									onClick={handleSubmit(this.onSubmit.bind(this))}
									disabled={this.ableToEdit()}
								/>
							</div>
						</form>
					</CardText>
				</Card>
			</div>
		);
	}
}

function mapStateToProps(store) {
	const selector = formValueSelector("HolidayForm");
	return {
		holiday: store.holiday.holiday,
		modeCRU: store.holiday.modeCRU,
		rol: store.app.rol,
		formValues: selector(
			store,
			"all_types_of_flight",
			"flights_types_list",
			"date"
		)
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionCreateHoliday,
			actionUpdateHoliday,
			actionCopyHoliday
		},
		dispatch
	);
}
export default reduxForm({
	form: "HolidayForm"
})(connect(mapStateToProps, mapDispatchToProps)(HolidayForm));



// WEBPACK FOOTER //
// ./src/screens/Holiday/HolidayForm.js